import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/views/MapEditor/utils';
import React, { useRef } from 'react';

const ControlBtn = ({
  direction,
  type,
  clickCallBack,
}: {
  direction: 'left' | 'right';
  type: 'editForm' | 'legend';
  clickCallBack?: Function;
}) => {
  switch (type) {
    case 'editForm':
      return (
        <>
          {direction === 'left' && (
            <div
              className="map-editor-left-search"
              onClick={() => {
                clickCallBack && clickCallBack();
              }}
            >
              <div className="search-icon">
                <i></i>
                搜索
              </div>
              <div className="expand-icon">
                <i className="map-editor-icon-left"></i>
              </div>
            </div>
          )}
          {direction === 'right' && (
            <i
              className="map-editor-edit-form-btn map-editor-icon-right"
              onClick={() => {
                clickCallBack && clickCallBack();
              }}
            ></i>
          )}
        </>
      );
    case 'legend':
      return (
        <>
          {direction === 'left' && (
            <i
              className="map-editor-legend-btn map-editor-icon-left"
              onClick={() => {
                clickCallBack && clickCallBack();
              }}
            ></i>
          )}
          {direction === 'right' && (
            <i
              className="map-editor-legend-btn map-editor-icon-right"
              onClick={() => {
                clickCallBack && clickCallBack();
              }}
              clstag={clstagStr(CLSTAG.LegendExpandFold)}
            ></i>
          )}
        </>
      );
    default:
      return <></>;
  }
};

export default React.memo(ControlBtn);
